import type { RouteObject } from 'react-router';

export const teamWebhookRoutes: RouteObject[] = [
  {
    path: 'webhooks',
    lazy: () => import('./page.js'),
    children: [
      { index: true, lazy: () => import('./index/page.js') },
      { path: 'new', lazy: () => import('./new/page.js') },
      { path: ':integrationId', lazy: () => import('./[integrationId]/page.js') },
    ],
  },
];
